// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__AcWGP","inner":"Footer_inner__X-XDt","copyright":"Footer_copyright__lghYs","separator":"Footer_separator__R0qVx","link":"Footer_link__ljLIL"};